import React, { ChangeEvent, FC, useState } from 'react';
import { Input } from 'antd';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import styles from './COSearch.module.scss';

export interface COSearchProps {
  placeholderString: string;
  name?: string;
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  inputValue?: string;
  border?: boolean;
}

const COSearch: FC<COSearchProps> = ({
  placeholderString,
  name,
  handleChange,
  inputValue,
  border,
}: COSearchProps) => {
  const [showPlaceholder, setShowPlaceHolder] = useState<boolean>(false);
  const handleShowPlaceholder = () => setShowPlaceHolder(true);

  const handleHidePlaceholder = () => setShowPlaceHolder(false);

  return border ? (
    <div className={styles.searchBarContainerBorder}>
      <SearchIcon className={styles.searchIcon} />
      <Input
        placeholder={placeholderString}
        name={name}
        type="text"
        className={styles.searchBar}
        value={inputValue}
        onChange={handleChange}
      />
    </div>
  ) : (
    <div className={styles.searchBarContainer}>
      <SearchIcon />
      <Input
        placeholder={showPlaceholder ? placeholderString : ''}
        name={name}
        type="text"
        className={styles.searchBar}
        value={inputValue}
        onChange={handleChange}
        onFocus={handleShowPlaceholder}
        onBlur={handleHidePlaceholder}
      />
    </div>
  );
};

export default COSearch;
